export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '6b0a52ce-7f7e-4ca9-a7a6-2dcb7ad2f93b';
export const MODAL_CLOSE_SEC = 2.5;
